export default "__VITE_ASSET__CghKXWOJ__"